import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import { accountLogin, codeLogin, checkCasid, fetchLogoutUrl, fetchScanInfo } from '@api/login';
import Cookies from 'js-cookie';

export default {
  namespaced: true,
  actions: {
    /**
     * @description 扫码验证
     * @param {Object} payload code {String} 二维码code
     */
    fetchScanInfo(_, { code = '' }) {
      return new Promise((resolve, reject) => {
        fetchScanInfo(code)
          .then(async res => {
            if (res.id || res.thirdPartyId || res.uid) {
              if (res.schoolId === '') {
                resolve({
                  flag: 'noAuth',
                  message: `您所在的学校 ${res.defaultSchoolName} 未开通，请联系管理员`
                });
              } else {
                util.cookies.set('casid', res.casId, { domain: '.hitecloud.net' });
                util.cookies.set('casid', res.casId, { domain: '.hitecloud.cn' });
                if (process.env.NODE_ENV === 'development') {
                  util.cookies.set('casid', res.casId);
                }
                resolve({ flag: true });
              }
            } else {
              if (res === '未找到绑定信息') {
                resolve({
                  flag: 'noScan',
                  message: res
                });
              } else if (res.confirm === 0) {
                resolve({
                  flag: 'scan',
                  message: res.realname
                });
              } else if (res.confirm === -1) {
                resolve({
                  flag: 'cancelLogin',
                  message: res.realname
                });
              } else {
                resolve({
                  flag: 'noAuth',
                  message: res
                });
              }
            }
          })
          .catch(err => {
            reject(false);
          });
      });
    },
    /**
     * @description casid验证
     * @param {Object} payload casid {String} casid
     */
    checkCasid({ dispatch }, { casid = '' }) {
      return new Promise((resolve, reject) => {
        checkCasid({ casId: casid })
          .then(async res => {
            if (!res) {
              resolve({
                flag: false,
                message: res
              });
            } else if (res.id || res.thirdPartyId || res.uid) {
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天
              const id = res.uid || res.thirdPartyId;
              const username = res.username;

              util.cookies.set('uuid', id);
              util.cookies.set('token', res.token);
              const userType =
                res.userType === '0'
                  ? res.realName === '超级管理员' || res.realName === '管理员'
                    ? '0'
                    : '10'
                  : res.userType;
              util.cookies.set('userType', userType);
              util.cookies.set('casid', casid, { domain: '.hitecloud.net' });
              util.cookies.set('casid', casid, { domain: '.hitecloud.cn' });
              if (process.env.NODE_ENV === 'development') {
                util.cookies.set('casid', casid);
              }

              //记住密码
              global.localStorage.setItem('username', username);
              // global.localStorage.removeItem('password');
              // 设置 vuex 用户信息
              // if (
              //   username === '13310029630' ||
              //   username === '15613282905' ||
              //   username === '13633121852'
              // ) {
              if (res.userType === '0') {
                dispatch(
                  'd2admin/user/set',
                  {
                    username,
                    userMobile: res.mobile || username,
                    realName: res.realName || username,
                    schoolId: '',
                    schoolName: null,
                    analysisModule: '0',
                    userId: '5d1bfc52ab5e43568bc6a1ade8f1663b',
                    // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员；10: '分配的管理员'
                    userType:
                      res.realName === '超级管理员' || res.realName === '管理员' ? '0' : '10'
                  },
                  {
                    root: true
                  }
                );
                await dispatch(
                  'ai/teacher/setSelectedSchoolForLogin',
                  {
                    selectedSchool: ''
                  },
                  {
                    root: true
                  }
                );
              } else {
                dispatch(
                  'd2admin/user/set',
                  {
                    username,
                    userMobile: res.mobile,
                    realName: res.realName,
                    schoolId: res.schoolId,
                    schoolName: res.defaultSchoolName,
                    analysisModule: res.analysisModule,
                    userId: res.id || res.thirdPartyId || res.uuid,
                    userType: res.userType // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
                  },
                  {
                    root: true
                  }
                );
                await dispatch(
                  'ai/teacher/setSelectedSchoolForLogin',
                  {
                    selectedSchool: res.schoolId
                  },
                  {
                    root: true
                  }
                );
              }
              // await dispatch(
              //   'd2admin/user/set',
              //   {
              //     username,
              //     userMobile: res.mobile,
              //     realName: res.realName,
              //     schoolId: res.schoolId,
              //     schoolName: res.defaultSchoolName,
              //     analysisModule: res.analysisModule,
              //     userId: res.id || res.thirdPartyId || res.uid,
              //     userType: res.userType // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
              //   },
              //   {
              //     root: true
              //   }
              // );
              // await dispatch(
              //   'ai/teacher/setSelectedSchoolForLogin',
              //   {
              //     selectedSchool: res.schoolId
              //   },
              //   {
              //     root: true
              //   }
              // );
              // 用户登录后从持久化数据加载一系列的设置
              await dispatch('load');
              if (res.schoolId === '') {
                await dispatch(
                  'd2admin/user/set',
                  {
                    message: `您所在的学校 ${res.defaultSchoolName} 未开通，请联系管理员`
                  },
                  {
                    root: true
                  }
                );
                resolve({
                  flag: false,
                  message: `您所在的学校 ${res.defaultSchoolName} 未开通，请联系管理员`
                });
              } else {
                resolve({ flag: true });
              }
            } else {
              console.log(123);
              await dispatch(
                'd2admin/user/set',
                {
                  message: res
                },
                {
                  root: true
                }
              );
              resolve({
                flag: false,
                message: res
              });
            }
            // 结束
          })
          .catch(err => {
            reject(false);
          });
      });
    },

    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login({ dispatch }, { username = '', password = '', isSavePwd = false } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        accountLogin({
          username,
          password
        })
          .then(async res => {
            if (res.id || res.thirdPartyId || res.uuid) {
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天
              const id = res.uuid || res.thirdPartyId;
              // 解决第一次登录时，未输入验证码也能进入平台的问题
              if (global.localStorage.getItem(username) === username) {
                util.cookies.set('uuid', id);
                util.cookies.set('token', res.token);
                // if (
                //   username === '13310029630' ||
                //   username === '15613282905' ||
                //   username === '13633121852'
                // ) {
                if (res.userType === '0') {
                  util.cookies.set('casid', null, { domain: '.hitecloud.net' });
                  util.cookies.set('casid', null, { domain: '.hitecloud.cn' });
                  if (process.env.NODE_ENV === 'development') {
                    util.cookies.set('casid', null);
                  }
                } else {
                  util.cookies.set('casid', res.casId, { domain: '.hitecloud.net' });
                  util.cookies.set('casid', res.casId, { domain: '.hitecloud.cn' });
                  if (process.env.NODE_ENV === 'development') {
                    util.cookies.set('casid', res.casId);
                  }
                }
                //   util.cookies.set('casid', res.casId, { domain: '.hitecloud.net' });
                // util.cookies.set('casid', res.casId, { domain: '.hitecloud.cn' });
              }
              // 用户身份
              const userType =
                res.userType === '0'
                  ? res.realName === '超级管理员' || res.realName === '管理员'
                    ? '0'
                    : '10'
                  : res.userType;
              util.cookies.set('userType', userType);
              util.cookies.set('loginTime', new Date().getTime());
              global.localStorage.setItem('username', username);
              if (isSavePwd) {
                global.localStorage.setItem('password', password);
              } else {
                global.localStorage.removeItem('password');
              }
              // 设置 vuex 用户信息
              // if (
              //   username === '13310029630' ||
              //   username === '15613282905' ||
              //   username === '13633121852'
              // ) {
              if (res.userType === '0') {
                dispatch(
                  'd2admin/user/set',
                  {
                    username,
                    userMobile: res.mobile || username,
                    realName: res.realName || username,
                    schoolId: '',
                    schoolName: null,
                    analysisModule: '0',
                    userId: '5d1bfc52ab5e43568bc6a1ade8f1663b',
                    // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员；10: '分配的管理员'
                    userType:
                      res.realName === '超级管理员' || res.realName === '管理员' ? '0' : '10'
                  },
                  {
                    root: true
                  }
                );
                await dispatch(
                  'ai/teacher/setSelectedSchoolForLogin',
                  {
                    selectedSchool: ''
                  },
                  {
                    root: true
                  }
                );
              } else {
                dispatch(
                  'd2admin/user/set',
                  {
                    username,
                    userMobile: res.mobile,
                    realName: res.realName,
                    schoolId: res.schoolId,
                    schoolName: res.defaultSchoolName,
                    analysisModule: res.analysisModule,
                    userId: res.id || res.thirdPartyId || res.uuid,
                    userType: res.userType // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
                  },
                  {
                    root: true
                  }
                );
                await dispatch(
                  'ai/teacher/setSelectedSchoolForLogin',
                  {
                    selectedSchool: res.schoolId
                  },
                  {
                    root: true
                  }
                );
              }
              // await dispatch(
              //   'd2admin/user/set',
              //   {
              //     username,
              //     userMobile: res.mobile,
              //     realName: res.realName,
              //     schoolId: res.schoolId,
              //     schoolName: res.defaultSchoolName,
              //     analysisModule: res.analysisModule,
              //     userId: res.id || res.thirdPartyId || res.uuid,
              //     userType: res.userType // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
              //   },
              //   {
              //     root: true
              //   }
              // );
              // await dispatch(
              //   'ai/teacher/setSelectedSchoolForLogin',
              //   {
              //     selectedSchool: res.schoolId
              //   },
              //   {
              //     root: true
              //   }
              // );
              // 用户登录后从持久化数据加载一系列的设置
              await dispatch('load');
              // }
              //  else if (
              //   username === '13310029630' ||
              //   username === '15613282905' ||
              //   username === '13633121852'
              // ) {
              //   dispatch(
              //     'd2admin/user/set',
              //     {
              //       username,
              //       userMobile: username,
              //       realName: res.realName || username,
              //       schoolId: '',
              //       schoolName: null,
              //       analysisModule: '0',
              //       userId: '5d1bfc52ab5e43568bc6a1ade8f1663b',
              //       userType: '0' // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
              //     },
              //     {
              //       root: true
              //     }
              //   );
              //   await dispatch(
              //     'ai/teacher/setSelectedSchoolForLogin',
              //     {
              //       selectedSchool: ''
              //     },
              //     {
              //       root: true
              //     }
              //   );
              //   await dispatch('load');
            } else {
              await dispatch(
                'd2admin/user/set',
                {
                  message: res
                },
                {
                  root: true
                }
              );
            }
            // 结束
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * @description 验证码登录
     * @param {Object} context
     * @param {Object} payload name {String} 用户账号
     * @param {Object} payload mobile {String} 手机号
     * @param {Object} payload code {String} 手机验证码
     */
    codeLogin({ dispatch }, { name = '', mobile = '', code = '' } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        codeLogin({
          name,
          mobile,
          code
        })
          .then(async res => {
            if (res.id || res.thirdPartyId || res.uuid) {
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天
              const id = res.uuid || res.thirdPartyId;
              util.cookies.set('uuid', id);
              util.cookies.set('token', res.token);
              const userType =
                res.userType === '0'
                  ? res.realName === '超级管理员' || res.realName === '管理员'
                    ? '0'
                    : '10'
                  : res.userType;
              util.cookies.set('userType', userType);
              util.cookies.set('loginTime', new Date().getTime());
              // util.cookies.set('casid', res.casId);
              // util.cookies.set('casid', res.casId, { domain: '.hitecloud.net' });
              // util.cookies.set('casid', res.casId, { domain: '.hitecloud.cn' });
              // if (name === '13310029630' || name === '15613282905' || name === '13633121852') {
              if (res.userType === '0') {
                util.cookies.set('casid', null, { domain: '.hitecloud.net' });
                util.cookies.set('casid', null, { domain: '.hitecloud.cn' });
                if (process.env.NODE_ENV === 'development') {
                  util.cookies.set('casid', null);
                }
              } else {
                util.cookies.set('casid', res.casId, { domain: '.hitecloud.net' });
                util.cookies.set('casid', res.casId, { domain: '.hitecloud.cn' });
                if (process.env.NODE_ENV === 'development') {
                  util.cookies.set('casid', res.casId);
                }
              }

              // 设置 vuex 用户信息
              // 设置 vuex 用户信息
              // if (name === '13310029630' || name === '15613282905' || name === '13633121852') {
              if (res.userType === '0') {
                dispatch(
                  'd2admin/user/set',
                  {
                    username: name,
                    userMobile: name,
                    realName: res.realName || name,
                    schoolId: '',
                    schoolName: null,
                    analysisModule: '0',
                    userId: '5d1bfc52ab5e43568bc6a1ade8f1663b',
                    // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员；10: '分配的管理员'
                    userType:
                      res.realName === '超级管理员' || res.realName === '管理员' ? '0' : '10'
                  },
                  {
                    root: true
                  }
                );
                await dispatch(
                  'ai/teacher/setSelectedSchoolForLogin',
                  {
                    selectedSchool: ''
                  },
                  {
                    root: true
                  }
                );
              } else {
                dispatch(
                  'd2admin/user/set',
                  {
                    username: name,
                    userMobile: res.mobile,
                    realName: res.realName,
                    schoolId: res.schoolId,
                    schoolName: res.defaultSchoolName,
                    analysisModule: res.analysisModule,
                    userId: res.id || res.thirdPartyId || res.uuid,
                    userType: res.userType // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
                  },
                  {
                    root: true
                  }
                );
                await dispatch(
                  'ai/teacher/setSelectedSchoolForLogin',
                  {
                    selectedSchool: res.schoolId
                  },
                  {
                    root: true
                  }
                );
              }
              // await dispatch(
              //   'd2admin/user/set',
              //   {
              //     username: name,
              //     userMobile: res.mobile,
              //     realName: res.realName,
              //     schoolId: res.schoolId,
              //     schoolName: res.defaultSchoolName,
              //     analysisModule: res.analysisModule,
              //     userId: res.id || res.thirdPartyId || res.uuid,
              //     userType: res.userType // 用户角色：1、教师；2：班主任；5、管理员；0：超级管理员
              //   },
              //   {
              //     root: true
              //   }
              // );
              // await dispatch(
              //   'ai/teacher/setSelectedSchoolForLogin',
              //   {
              //     selectedSchool: res.schoolId
              //   },
              //   {
              //     root: true
              //   }
              // );
              // 用户登录后从持久化数据加载一系列的设置
              await dispatch('load');
            }
            // 结束
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }, { confirm = false } = {}) {
      /**
       * @description 注销
       */
      async function logout() {
        // 删除cookie
        util.cookies.remove('token');
        util.cookies.remove('uuid');
        util.cookies.remove('casid');
        util.cookies.remove('loginTime');
        Cookies.remove('casid', { domain: '.hitecloud.net' });
        Cookies.remove('casid', { domain: '.hitecloud.cn' });
        Cookies.remove('casid');

        // 清空 vuex 用户信息
        await dispatch(
          'd2admin/user/set',
          {},
          {
            root: true
          }
        );
        // 跳转路由
        router.push({
          name: 'login'
        });
        // if (
        //   global.localStorage.getItem('username') !== 'superadmin' ||
        //   global.localStorage.getItem('username') !== 'admin' ||
        //   global.localStorage.getItem('username') === '13310029630' ||
        //   global.localStorage.getItem('username') === '15613282905' ||
        //   global.localStorage.getItem('username') === '13633121852'
        // ) {
        if (util.cookies.get('userType') !== '0') {
          fetchLogoutUrl().then(res => {
            res.map(item => {
              if (item.ca_logouturl) {
                const img = document.createElement('img');
                img.style.display = 'none'; // 防止影响页面
                img.src = item.ca_logouturl;
                document.body.appendChild(img); // 这一行必须，img挂载到dom树上才会发请求
              }
            });
          });
        }
      }
      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前登录状态吗', '退出登录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            commit('d2admin/gray/set', false, {
              root: true
            });
            logout();
          })
          .catch(() => {
            commit('d2admin/gray/set', false, {
              root: true
            });
            Message({
              message: '取消退出登录'
            });
          });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load({ dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, {
          root: true
        });
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, {
          root: true
        });
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, {
          root: true
        });
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, {
          root: true
        });
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, {
          root: true
        });
        // end
        resolve();
      });
    }
  }
};
